(function () {
  var root = document.getElementById('Flipbook');
  var configNode = document.getElementById('FlipbookConfig');
  if (!root || !configNode || !window.St || !window.St.PageFlip) return;

  var config = JSON.parse(configNode.textContent);
  var labels = config.labels;
  var kit = new URLSearchParams(window.location.search).get('kit');
  var catalog = (config.catalogs || []).filter(function (item) { return item.id === kit; })[0];
  var loading = root.querySelector('[data-flipbook-loading]');
  var chooser = root.querySelector('[data-flipbook-chooser]');
  var errorBox = root.querySelector('[data-flipbook-error]');
  var status = root.querySelector('[data-flipbook-status]');
  var bar = root.querySelector('[data-flipbook-bar]');
  var book = document.getElementById('FlipbookBook');
  var count = root.querySelector('[data-flipbook-count]');
  var range = root.querySelector('[data-flipbook-range]');
  var prev = root.querySelector('[data-flipbook-prev]');
  var next = root.querySelector('[data-flipbook-next]');
  var zoomIn = root.querySelector('[data-flipbook-zoom-in]');
  var zoomOut = root.querySelector('[data-flipbook-zoom-out]');
  var fullscreenBtn = root.querySelector('[data-flipbook-fullscreen]');
  var soundBtn = root.querySelector('[data-flipbook-sound]');
  var heading = root.querySelector('.flipbook__sr');

  if (!catalog) {
    loading.hidden = true;
    chooser.hidden = false;
    return;
  }

  heading.textContent = catalog.title;
  document.title = catalog.title + ' | ' + config.shop;
  root.querySelector('[data-flipbook-pdf]').href = catalog.pdf;

  var sourcesNode = document.getElementById('FlipbookPages');
  var sources = sourcesNode ? JSON.parse(sourcesNode.textContent) : {};
  var pageList = (sources[catalog.id] && sources[catalog.id].pages) || [];
  var pageSize = sources[catalog.id] || { width: 595, height: 842 };
  if (!pageList.length) {
    loading.hidden = true;
    showError();
    return;
  }

  var flip = null;
  var pdfDoc = null;
  var opened = false;
  var pageNodes = [];
  var soundReady = false;
  var muted = false;
  var audioCtx = null;
  var zoomIndex = 0;
  var zoomSteps = [1, 1.45, 1.9];
  try { muted = window.localStorage.getItem('melodi-flip-sound') === '0'; } catch (e) {}
  paintSound();

  function setProgress(text, ratio) {
    status.textContent = text;
    bar.style.width = Math.max(0, Math.min(1, ratio || 0)) * 100 + '%';
  }

  function showError() {
    loading.hidden = true;
    errorBox.hidden = false;
  }

  function targetWidth() {
    return window.innerWidth < 800 ? 1100 : 1500;
  }

  function paintSound() {
    var on = soundBtn.querySelector('[data-flipbook-sound-on]');
    var off = soundBtn.querySelector('[data-flipbook-sound-off]');
    on.hidden = muted;
    off.hidden = !muted;
    soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    soundBtn.setAttribute('aria-label', muted ? labels.soundOff : labels.soundOn);
  }

  function playFlip() {
    if (muted || !soundReady) return;
    var Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    if (audioCtx.state === 'suspended') audioCtx.resume();
    var duration = 0.16;
    var buffer = audioCtx.createBuffer(1, Math.floor(audioCtx.sampleRate * duration), audioCtx.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < data.length; i++) {
      var fade = Math.pow(1 - i / data.length, 2);
      data[i] = (Math.random() * 2 - 1) * fade * 0.22;
    }
    var source = audioCtx.createBufferSource();
    var filter = audioCtx.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = 1400;
    source.buffer = buffer;
    source.connect(filter);
    filter.connect(audioCtx.destination);
    source.start();
  }

  function isSpread() {
    if (flip) return flip.getOrientation() === 'landscape';
    return window.innerWidth >= 560;
  }

  function pairIndex(index) {
    if (!isSpread() || index % 2 === 0) return index;
    return index - 1;
  }

  function spreadLabel() {
    var index = flip.getCurrentPageIndex();
    var total = flip.getPageCount();
    var page = index + 1;
    var end = page;
    if (flip.getOrientation() === 'landscape' && index < total - 1) end = page + 1;
    return (page === end ? String(page) : page + '-' + end) + ' / ' + total;
  }

  function atEnd() {
    var index = flip.getCurrentPageIndex();
    var total = flip.getPageCount();
    if (flip.getOrientation() === 'landscape') return index >= total - 2;
    return index >= total - 1;
  }

  var arrowAnchor = null;
  function placeArrows(force) {
    if (!flip) return;
    if (window.innerWidth < 750 || zoomIndex > 0) {
      arrowAnchor = null;
      prev.style.left = '';
      prev.style.top = '';
      next.style.left = '';
      next.style.right = '';
      next.style.top = '';
      root.classList.add('is-placed');
      return;
    }
    if (!arrowAnchor || force) {
      var bounds = flip.getBoundsRect();
      var block = book.querySelector('.stf__block') || book;
      var stage = book.parentElement.getBoundingClientRect();
      if (!bounds || bounds.width < 200 || bounds.height < 200 || stage.height < 200) return;
      var blockRect = block.getBoundingClientRect();
      var left = blockRect.left + bounds.left;
      var right = left + bounds.width;
      var mid = blockRect.top + bounds.top + bounds.height / 2 - stage.top;
      arrowAnchor = {
        mid: mid + 'px',
        prevLeft: Math.max(8, left - stage.left - 58) + 'px',
        nextLeft: Math.min(stage.width - 54, right - stage.left + 12) + 'px'
      };
    }
    prev.style.top = arrowAnchor.mid;
    prev.style.left = arrowAnchor.prevLeft;
    next.style.top = arrowAnchor.mid;
    next.style.right = 'auto';
    next.style.left = arrowAnchor.nextLeft;
    root.classList.add('is-placed');
  }

  function scheduleArrows() {
    placeArrows(false);
  }

  function updateUi() {
    if (!flip) return;
    book.style.transform = '';
    var index = flip.getCurrentPageIndex();
    count.textContent = spreadLabel();
    range.max = String(Math.max(0, flip.getPageCount() - 1));
    range.value = String(index);
    range.setAttribute('aria-valuetext', count.textContent);
    prev.disabled = index <= 0;
    next.disabled = atEnd();
    var hash = '#page/' + (index + 1);
    if (window.location.hash !== hash) window.history.replaceState(null, '', hash);
    scheduleArrows();
  }

  function applyZoom() {
    var stage = root.querySelector('.flipbook__stage');
    var viewport = root.querySelector('.flipbook__viewport');
    var zoom = zoomSteps[zoomIndex];
    if (zoom === 1) {
      stage.style.width = '';
      stage.style.height = '';
      book.style.width = '';
      book.style.height = '';
    } else {
      var width = Math.round(viewport.clientWidth * zoom);
      var height = Math.round(viewport.clientHeight * zoom);
      stage.style.width = width + 'px';
      stage.style.height = height + 'px';
      book.style.width = width + 'px';
      book.style.height = height + 'px';
    }
    zoomOut.disabled = zoomIndex === 0;
    zoomIn.disabled = zoomIndex === zoomSteps.length - 1;
    if (flip) {
      flip.getUI().update();
      arrowAnchor = null;
      placeArrows(true);
    }
  }

  function visibleIndexes(index) {
    var base = pairIndex(index);
    var list = [base];
    if (isSpread() && base + 1 < pageList.length) list.push(base + 1);
    return list;
  }

  function arm(index) {
    var base = pairIndex(index);
    var from = base - (isSpread() ? 2 : 1);
    var to = base + (isSpread() ? 3 : 1);
    for (var i = from; i <= to; i++) {
      if (i < 0 || i >= pageList.length) continue;
      var img = pageNodes[i].querySelector('img');
      if (img.dataset.armed === '1') continue;
      img.dataset.armed = '1';
      img.alt = labels.page + ' ' + (i + 1);
      if (i === start || i === start + 1) img.fetchPriority = 'high';
      img.addEventListener('load', function () {
        this.parentElement.classList.add('is-ready');
      });
      img.src = pageList[i];
    }
  }

  function waitFor(indexes) {
    return Promise.all(indexes.map(function (i) {
      var img = pageNodes[i].querySelector('img');
      if (img.complete) return Promise.resolve(img.naturalWidth > 0);
      return new Promise(function (resolve) {
        img.addEventListener('load', function () { resolve(true); }, { once: true });
        img.addEventListener('error', function () { resolve(false); }, { once: true });
      });
    }));
  }

  var turning = false;
  function step() { return isSpread() ? 2 : 1; }
  function goTo(index, animate) {
    if (!flip || turning) return;
    index = pairIndex(index);
    if (index < 0) index = 0;
    if (index >= pageList.length) index = pairIndex(pageList.length - 1);
    if (index === flip.getCurrentPageIndex()) return;
    turning = true;
    arm(index);
    waitFor(visibleIndexes(index)).then(function (ready) {
      turning = false;
      if (!flip || ready.indexOf(false) !== -1) return;
      var current = flip.getCurrentPageIndex();
      if (index === current) return;
      if (animate && index === current + step()) flip.flipNext();
      else if (animate && index === current - step()) flip.flipPrev();
      else flip.turnToPage(index);
    });
  }

  prev.addEventListener('click', function () { if (flip) goTo(flip.getCurrentPageIndex() - step(), true); });
  next.addEventListener('click', function () { if (flip) goTo(flip.getCurrentPageIndex() + step(), true); });
  zoomIn.addEventListener('click', function () {
    if (zoomIndex < zoomSteps.length - 1) { zoomIndex += 1; applyZoom(); }
  });
  zoomOut.addEventListener('click', function () {
    if (zoomIndex > 0) { zoomIndex -= 1; applyZoom(); }
  });
  book.addEventListener('dblclick', function () {
    zoomIndex = zoomIndex === 0 ? zoomSteps.length - 1 : 0;
    applyZoom();
  });
  fullscreenBtn.addEventListener('click', function () {
    if (document.fullscreenElement) document.exitFullscreen();
    else root.requestFullscreen().catch(function () {});
  });
  document.addEventListener('fullscreenchange', function () {
    var active = !!document.fullscreenElement;
    fullscreenBtn.setAttribute('aria-label', active ? labels.exitFullscreen : labels.fullscreen);
  });
  soundBtn.addEventListener('click', function () {
    muted = !muted;
    try { window.localStorage.setItem('melodi-flip-sound', muted ? '0' : '1'); } catch (e) {}
    paintSound();
  });
  range.addEventListener('input', function () {
    var index = pairIndex(Number(range.value));
    var page = index + 1;
    var end = isSpread() && index + 1 < pageList.length ? page + 1 : page;
    count.textContent = (page === end ? String(page) : page + '-' + end) + ' / ' + pageList.length;
  });
  range.addEventListener('change', function () {
    if (flip) goTo(Number(range.value), false);
  });
  document.addEventListener('keydown', function (event) {
    if (!flip) return;
    var tag = event.target && event.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;
    if (event.key === 'ArrowRight') goTo(flip.getCurrentPageIndex() + step(), true);
    else if (event.key === 'ArrowLeft') goTo(flip.getCurrentPageIndex() - step(), true);
    else if (event.key === 'Home') goTo(0, false);
    else if (event.key === 'End') goTo(pageList.length - 1, false);
  });
  window.addEventListener('resize', function () {
    if (!flip) return;
    arrowAnchor = null;
    if (zoomIndex > 0) applyZoom();
    arm(flip.getCurrentPageIndex());
    updateUi();
    placeArrows(true);
  });

  var hash = (window.location.hash.match(/^#page\/(\d+)/) || [])[1];
  var start = hash ? Math.max(0, Math.min(pageList.length - 1, Number(hash) - 1)) : 0;
  start = pairIndex(start);
  for (var i = 0; i < pageList.length; i++) {
    var node = document.createElement('div');
    node.className = 'flipbook__page';
    node.innerHTML = '<div class="flipbook__sheet"><img alt=""></div>';
    pageNodes.push(node);
  }
  visibleIndexes(start).concat(visibleIndexes(start + (isSpread() ? 2 : 1))).forEach(function (i) {
    if (!pageList[i]) return;
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = pageList[i];
    document.head.appendChild(link);
  });
  arm(start);

  function openBook() {
    flip = new window.St.PageFlip(book, {
      width: pageSize.width,
      height: pageSize.height,
      size: 'stretch',
      minWidth: 280,
      maxWidth: 900,
      minHeight: 360,
      maxHeight: 1280,
      drawShadow: true,
      maxShadowOpacity: 0.45,
      flippingTime: 700,
      usePortrait: true,
      autoSize: false,
      showCover: false,
      mobileScrollSupport: false,
      swipeDistance: 28,
      showPageCorners: true,
      clickEventForward: true,
      useMouseEvents: true,
      startPage: start
    });
    flip.loadFromHTML(pageNodes);
    flip.on('flip', function () {
      var index = flip.getCurrentPageIndex();
      arm(index);
      updateUi();
      playFlip();
    });
    flip.on('init', function () {
      soundReady = true;
      updateUi();
    });
    flip.on('changeOrientation', function () {
      arrowAnchor = null;
      arm(flip.getCurrentPageIndex());
      updateUi();
      placeArrows(true);
    });
    window.dispatchEvent(new Event('resize'));
    arrowAnchor = null;
    updateUi();
    placeArrows(true);
    root.classList.add('is-open', 'is-ready');
  }

  waitFor(visibleIndexes(start)).then(function (ready) {
    if (ready.indexOf(false) !== -1) {
      showError();
      return;
    }
    openBook();
  });
})();
